module.exports = __webpack_public_path__ + "static/media/example2.e8eae9ab.jpg";